<template>
    <div>
        <p><strong>Разрешение на работу</strong></p>
        <p v-if="data.series"><strong>Серия:</strong> {{ data.series }}</p>
        <p v-if="data.number"><strong>Номер:</strong> {{ data.number }}</p>
        <p v-if="data.dateOfIssue"><strong>Дата выдачи:</strong> {{ getFormattedDate(data.dateOfIssue) }}</p>
        <p v-if="data.identityDocumentNumber"><strong>Номер документа, удостоверяющего личность:</strong> {{ data.identityDocumentNumber }}</p>
        <p v-if="data.supportingDoc"><strong>Документ:</strong> {{ data.supportingDoc }}</p>
    </div>
</template>

<script>
import {getFormattedDate} from "@/tools/moment-date";

export default {
    name: "ExpertPanelReviewAboutWorkPermit",
    methods: {
        getFormattedDate,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>

</style>